import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;
import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { styleUtils } from '../styles';
export var overlayAnimationDurationMS = 350;
export var overlayFullAnimationDurationMS = 500;
var animationStateStyles = {
  entering: {
    opacity: 0
  },
  entered: {
    opacity: 1
  },
  exited: {
    opacity: 0
  }
};
var overlayFullKeyframes = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tfrom { \n\t\ttransform: translate3d(0, 100%, 0); \n\t}\n\tto { \n\t\ttransform: translate3d(0, 0, 0); \n\t}\n"])));
var overlayFullReverseKeyframes = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tfrom { transform: translate3d(0, 0, 0); }\n\tto { transform: translate3d(0, 100%, 0); }\n"])));
var fullScreenEnterStyles = css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tanimation-name: ", ";\n"])), overlayFullKeyframes);
var fullScreenLeaveStyles = css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tanimation-name: ", ";\n\tanimation-fill-mode: forwards;\n"])), overlayFullReverseKeyframes);
var fullScreenStyles = css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tbackground-color: #eee;\n\tdisplay: block;\n\tanimation-direction: normal;\n\tanimation-fill-mode: backwards;\n\tanimation-duration: ", "ms;\n"])), overlayFullAnimationDurationMS);
var viewportOverlay = css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tposition: fixed;\n\ttop: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tleft: 0px;\n"])));
export var StyledViewportOverlay = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t", "\n\tz-index: 10;\n\t@media print {\n\t\tposition: static;\n\t}\n"])), viewportOverlay);
export var StyledOverlay = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t", "\n\tdisplay: flex;\n\tflex-direction: column;\n\t", "\n\tz-index: 11;\n\ttransition: opacity ", "ms ease-in-out;\n\tbackground-color: ", ";\n\t@media print {\n\t\tposition: absolute;\n\t}\n\t", "\n\t", "\n"])), viewportOverlay, function (props) {
  return positionOverlay(props.position);
}, overlayAnimationDurationMS, styleUtils.overlay, function (props) {
  return props.isFullScreen && fullScreenStyles;
}, function (props) {
  return getAnimationStyle(props.animationState, props.isFullScreen);
});
function positionOverlay(position) {
  switch (position) {
    case 'left':
      return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\talign-items: start;\n\t\t\t\tjustify-content: start;\n\t\t\t"])));
    case 'right':
      return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\talign-items: end;\n\t\t\t\tjustify-content: start;\n\t\t\t"])));
    case 'top':
      return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\talign-items: start;\n\t\t\t\tjustify-content: start;\n\t\t\t"])));
    case 'bottom':
      return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\talign-items: start;\n\t\t\t\tjustify-content: end;\n\t\t\t"])));
    case 'centered':
      return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t"])));
  }
}
function getAnimationStyle(animationState, isFullScreen) {
  if (isFullScreen) {
    switch (animationState) {
      case 'entered':
      case 'entering':
        return fullScreenEnterStyles;
      case 'exiting':
      case 'exited':
        return fullScreenLeaveStyles;
      default:
        return null;
    }
  }
  return animationStateStyles[animationState];
}